import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, setupAutoTracking } from '@/utils/tracking';

/**
 * Analytics tracker component - add to App.tsx to track all page views
 */
export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Setup auto-tracking on mount
    setupAutoTracking();
  }, []);

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null; // This component renders nothing
}
